import { createRouter, createWebHistory } from 'vue-router';
import { isMobile } from '~/@func/isMobile';

let routes: any = [];
//PC版の場合
if (isMobile.value == false) {
  routes = [
    { name: 'login', path: '/', component: () => import('./login/index.vue') },
    { name: 'logout', path: '/logout', component: () => import('./logout/index.vue') },

    {
      path: '/home',
      component: () => import('./home/index.vue'),
      children: [
        {
          name: 'home',
          path: '',
          component: () => import('./home/menu/index.vue'),
        },
        {
          name: 'systemInformationDetail',
          path: 'information',
          component: () => import('./home/systemInformationDetail/index.vue'),
        },
      ],
    },
    {
      name: 'commonLogout',
      path: '/common/logout',
      component: () => import('./common/logout.vue'),
    },
    {
      path: '/inquiry',
      component: () => import('./inquiry/index.vue'),
      children: [
        {
          name: 'inquiryList',
          path: '',
          component: () => import('./inquiry/list/index.vue'),
        },
        {
          name: 'inquiryDetail',
          path: 'detail',
          component: () => import('./inquiry/detail/index.vue'),
        },
        {
          name: 'inquiryMatching',
          path: 'matching',
          component: () => import('./inquiry/matching/index.vue'),
        },
        {
          name: 'inquiryWarehouseCompare',
          path: 'compare',
          component: () => import('./inquiry/compare/index.vue'),
        },
        {
          name: 'inquiryContact',
          path: 'contact',
          component: () => import('./inquiry/contact/index.vue'),
        },
      ],
    },

    {
      path: '/warehouse_schedule',
      component: () => import('./warehouseSchedule/index.vue'),
      children: [
        {
          name: 'warehouseScheduleList',
          path: '',
          component: () => import('./warehouseSchedule/list/index.vue'),
        },
      ],
    },
    {
      path: '/order',
      component: () => import('./order/index.vue'),
      children: [
        {
          name: 'orderList',
          path: '',
          component: () => import('./order/list/index.vue'),
        },
        {
          name: 'orderDetail',
          path: 'detail',
          component: () => import('./order/detail/index.vue'),
        },
      ],
    },
    {
      path: '/order_status',
      component: () => import('./orderStatus/index.vue'),
      children: [
        {
          name: 'orderStatusList',
          path: '',
          component: () => import('./orderStatus/list/index.vue'),
        },
        {
          name: 'orderStatusDetail',
          path: 'detail',
          component: () => import('./orderStatus/detail/index.vue'),
        },
      ],
    },
    {
      path: '/amount',
      component: () => import('./amount/index.vue'),
      children: [
        {
          name: 'amountMenu',
          path: '',
          component: () => import('./amount/menu/index.vue'),
        },
        {
          name: 'amountClose',
          path: 'close',
          component: () => import('./amount/close/index.vue'),
        },
        {
          name: 'invoiceRow',
          path: 'invoice/row',
          component: () => import('./amount/invoiceRow/index.vue'),
        },
        {
          name: 'invoiceTotal',
          path: 'invoice/total',
          component: () => import('./amount/invoiceTotal/index.vue'),
        },
        {
          name: 'paymentRow',
          path: 'payment/row',
          component: () => import('./amount/paymentRow/index.vue'),
        },
        {
          name: 'paymentTotal',
          path: 'payment/total',
          component: () => import('./amount/paymentTotal/index.vue'),
        },
      ],
    },

    {
      path: '/client',
      component: () => import('./client/index.vue'),
      children: [
        {
          name: 'clientList',
          path: '',
          component: () => import('./client/list/index.vue'),
        },
        {
          name: 'clientDetail',
          path: 'detail',
          component: () => import('./client/detail/index.vue'),
        },
      ],
    },

    {
      path: '/warehouse_corp',
      component: () => import('./warehouse/index.vue'),
      children: [
        {
          name: 'warehouseCorpList',
          path: '',
          component: () => import('./warehouseCorp/list/index.vue'),
        },
        {
          name: 'warehouseCorpDetail',
          path: 'detail',
          component: () => import('./warehouseCorp/detail/index.vue'),
        },
        {
          name: 'warehouseSystemUserDetail',
          path: 'system_user',
          component: () => import('./warehouseCorp/systemUser/index.vue'),
        },
      ],
    },

    {
      path: '/warehouse',
      component: () => import('./warehouse/index.vue'),
      children: [
        {
          name: 'warehouseList',
          path: '',
          component: () => import('./warehouse/list/index.vue'),
        },
        {
          name: 'warehouseDetail',
          path: 'detail',
          component: () => import('./warehouse/detail/index.vue'),
        },
      ],
    },
    {
      path: '/contact',
      component: () => import('./contact/index.vue'),
      children: [
        {
          name: 'contactList',
          path: '',
          component: () => import('./contact/list/index.vue'),
        },
        {
          name: 'contactDetail',
          path: 'detail',
          component: () => import('./contact/detail/index.vue'),
        },
      ],
    },
    {
      path: '/client_system_user',
      component: () => import('./clientSystemUser/index.vue'),
      children: [
        {
          name: 'clientSystemUserList',
          path: '',
          component: () => import('./clientSystemUser/list/index.vue'),
        },
        {
          name: 'clientSystemUserDetail',
          path: 'detail',
          component: () => import('./clientSystemUser/detail/index.vue'),
        },
      ],
    },
    {
      path: '/config',
      component: () => import('./config/index.vue'),
      children: [
        {
          name: 'configMenu',
          path: 'menu',
          component: () => import('./config/menu/index.vue'),
        },
        {
          name: 'configParsonal',
          path: 'parsonal',
          component: () => import('./config/parsonal/index.vue'),
        },
        {
          name: 'configUser',
          path: 'user',
          component: () => import('./config/user/index.vue'),
        },
        {
          name: 'configUserDetail',
          path: 'user/detail',
          component: () => import('./config/user/detail/index.vue'),
        },

        {
          name: 'configUserBelong',
          path: 'user_belong',
          component: () => import('./config/userBelong/index.vue'),
        },
        {
          name: 'configUserBelongDetail',
          path: 'user_belong/detail',
          component: () => import('./config/userBelong/detail/index.vue'),
        },
        {
          name: 'configSystemInformation',
          path: 'system_information',
          component: () => import('./config/systemInformation/index.vue'),
        },
        {
          name: 'configSystemInformationDetail',
          path: 'system_information/detail',
          component: () => import('./config/systemInformation/detail/index.vue'),
        },

        {
          name: 'configSetting',
          path: 'setting',
          component: () => import('./config/setting/index.vue'),
        },
        {
          name: 'configSettingDetail',
          path: 'setting/detail',
          component: () => import('./config/setting/detail/index.vue'),
        },

        {
          name: 'configBank',
          path: 'bank',
          component: () => import('./config/bank/index.vue'),
        },

        {
          name: 'configPrintFormat',
          path: 'print_format',
          component: () => import('./config/printFormat/index.vue'),
        },
        {
          name: 'configInquirySimuration',
          path: 'inquiry_simuration',
          component: () => import('./config/inquirySimuration/index.vue'),
        },
        {
          name: 'configCsv',
          path: 'csv',
          component: () => import('./config/csv/index.vue'),
        },

        {
          name: 'configUpdate',
          path: 'update',
          component: () => import('./config/update/index.vue'),
        },
        {
          name: 'configCity',
          path: 'city',
          component: () => import('./config/city/index.vue'),
        },
      ],
    },
    //NotFoundページは一番最後に書く必要がある
    {
      name: 'notFound',
      path: '/:catchAll(.*)',
      component: () => import('./common/notFound.vue'),
    },
  ];
}

//スマホ版の場合
if (isMobile.value == true) {
  routes = [
    { name: 'login', path: '/', component: () => import('./login/index.vue') },
    { name: 'logout', path: '/logout', component: () => import('./logout/index.vue') },

    {
      path: '/home',
      component: () => import('./home/index.vue'),
      children: [
        {
          name: 'home',
          path: '',
          component: () => import('./home/menu/index.vue'),
        },
        {
          name: 'systemInformationDetail',
          path: 'information',
          component: () => import('./home/systemInformationDetail/index.vue'),
        },
      ],
    },
    {
      name: 'commonLogout',
      path: '/common/logout',
      component: () => import('./common/logout.vue'),
    },

    {
      path: '/inquiry',
      component: () => import('./inquiry/index.vue'),
      children: [
        {
          name: 'inquiryList',
          path: '',
          component: () => import('./inquiry/list/index.vue'),
        },
        {
          name: 'inquiryDetail',
          path: 'detail',
          component: () => import('./inquiry/detail/index.vue'),
        },
        {
          name: 'inquiryMatching',
          path: 'matching',
          component: () => import('./inquiry/matching/index.vue'),
        },
        {
          name: 'inquiryWarehouseCompare',
          path: 'compare',
          component: () => import('./inquiry/compare/index.vue'),
        },
        {
          name: 'inquiryContact',
          path: 'contact',
          component: () => import('./inquiry/contact/index.vue'),
        },
      ],
    },

    {
      path: '/warehouse_schedule',
      component: () => import('./warehouseSchedule/index.vue'),
      children: [
        {
          name: 'warehouseScheduleList',
          path: '',
          component: () => import('./warehouseSchedule/list/index.vue'),
        },
      ],
    },

    {
      path: '/warehouse',
      component: () => import('./warehouse/index.vue'),
      children: [
        {
          name: 'warehouseList',
          path: '',
          component: () => import('./warehouse/list/index.vue'),
        },
        {
          name: 'warehouseDetail',
          path: 'detail',
          component: () => import('./warehouse/detail/index.vue'),
        },
      ],
    },
    {
      path: '/config',
      component: () => import('./config/index.vue'),
      children: [
        {
          name: 'configMenu',
          path: 'menu',
          component: () => import('./common/notFound.vue'),
        },
        {
          name: 'configParsonal',
          path: 'parsonal',
          component: () => import('./config/parsonal/index.vue'),
        },
      ],
    },
    //NotFoundページは一番最後に書く必要がある
    {
      name: 'notFound',
      path: '/:catchAll(.*)',
      component: () => import('./common/notFound.vue'),
    },
  ];
}

const router = createRouter({
  routes,
  history: createWebHistory(),
});

export default router;
